import { useEffect, useRef } from "react";
import { useBalanceStore } from "../../store/BalanceStore";
import { ApiRequest } from "../../api/Api";
import styled from "styled-components";

export const Balance = () => {
	const { erc20, eth, trc20, trx, energy, maxEnergy, BalanceUpdate } =
		useBalanceStore();

	const timerRef = useRef<NodeJS.Timeout | null>(null);
	useEffect(() => {
		const BalanceUpdateTimer = async () => {
			const response = await ApiRequest("/main/balance");
			if (!response) {
				return;
			}
			BalanceUpdate(response.data);
			timerRef.current = setTimeout(BalanceUpdateTimer, 5000);
		};

		BalanceUpdateTimer();

		return () => {
			if (timerRef.current) {
				clearTimeout(timerRef.current);
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<StyledComponent>
			<div>
				<div>Eth:</div>
				<div>{eth}</div>
			</div>
			<div>
				<div>Erc20:</div>
				<div>{Math.floor(erc20)}</div>
			</div>
			<div>
				<div>Trx:</div>
				<div>{Math.floor(trx)}</div>
			</div>
			<div>
				<div>Trc20:</div>
				<div>{Math.floor(trc20)}</div>
			</div>
			<div>
				<div>Energy:</div>
				<div>
					{energy}/{maxEnergy}
				</div>
			</div>
		</StyledComponent>
	);
};

const timer: { id?: NodeJS.Timeout } = { id: undefined };

const StyledComponent = styled.div`
	display: flex;
	gap: 1rem;
	flex-wrap: wrap;

	& > div {
		padding: 1rem;
		background-color: rgba(255, 255, 255, 0.1);
		flex-grow: 1;
		text-align: center;
		display: flex;
		justify-content: space-between;
		gap: 1rem;
	}
`;
